import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a1985eee"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "background-color": "white",
    "padding": "20px"
  }
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "打卡统计", -1));
const _hoisted_3 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_el_row = _resolveComponent("el-row");
  const _component_BatterTableDataView = _resolveComponent("BatterTableDataView");
  const _component_LocationPicker = _resolveComponent("LocationPicker");
  const _component_DialogCustomView = _resolveComponent("DialogCustomView");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "crumbs"
  }, {
    default: _withCtx(() => [_createVNode(_component_svg_icon, {
      "icon-class": "house"
    }), _hoisted_2]),
    _: 1
  }), _createVNode(_component_el_row, {
    style: {
      "width": "100%"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_BatterTableDataView, {
      "table-id": "5"
    }, {
      "operates-handle": _withCtx(data => [_createElementVNode("span", {
        style: {
          "cursor": "pointer",
          "color": "#005FF5"
        },
        onClick: $event => $options.openMap(data.data)
      }, "查看位置", 8, _hoisted_3)]),
      _: 1
    })]),
    _: 1
  })]), _createVNode(_component_DialogCustomView, {
    "visible-control": $data.mapVisible,
    onClose: _cache[0] || (_cache[0] = $event => $data.mapVisible = false),
    title: "查看打卡位置"
  }, {
    default: _withCtx(() => [$data.mapVisible ? (_openBlock(), _createBlock(_component_LocationPicker, {
      key: 0,
      longitude: $data.longitude,
      latitude: $data.latitude
    }, null, 8, ["longitude", "latitude"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["visible-control"])], 64);
}